import { Box, Chip, Stack, Tooltip, Typography } from "@mui/material";
import { ReviewDetail } from "@/domain/eventInstance.interface";
import { getStatusDisplay } from "./statusDisplay";

interface Props {
	detail: ReviewDetail;
}

const fmt = (value?: string): string => {
	if (!value) return "—";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return value;
	return date.toLocaleString();
};

const Field = ({ label, value }: { label: string; value: string }) => (
	<Stack spacing={0.25}>
		<Typography variant="caption" color="text.secondary">
			{label}
		</Typography>
		<Typography variant="body2">{value}</Typography>
	</Stack>
);

export const SubmissionMetadata = ({ detail }: Props) => {
	const status = getStatusDisplay(detail.status);
	const review = detail.reviewMetadata;

	return (
		<Box
			sx={{
				display: "grid",
				gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
				gap: 2,
				p: 2,
				borderTop: "1px solid",
				borderColor: "divider",
			}}
		>
			<Field label="Participant" value={detail.beneficiaryName ?? "—"} />
			<Field label="Program" value={detail.programName ?? "—"} />
			<Field label="Event" value={detail.eventName ?? "—"} />
			<Field label="Submitted" value={fmt(detail.submittedAt)} />
			<Field label="Planned for" value={fmt(detail.plannedFor)} />
			<Stack spacing={0.25}>
				<Typography variant="caption" color="text.secondary">
					Status
				</Typography>
				<Tooltip title={status.description}>
					<Chip
						label={status.label}
						color={status.color}
						size="small"
						sx={{ alignSelf: "flex-start" }}
					/>
				</Tooltip>
			</Stack>
			{review?.reviewedAt && (
				<>
					<Field
						label="Reviewed by"
						value={review.reviewerName ?? review.reviewedBy ?? "—"}
					/>
					<Field label="Reviewed at" value={fmt(review.reviewedAt)} />
					{review.rejectionReason && (
						<Field label="Rejection reason" value={review.rejectionReason} />
					)}
					{review.reviewNotes && (
						<Field label="Review notes" value={review.reviewNotes} />
					)}
				</>
			)}
		</Box>
	);
};
